import React, { forwardRef } from "react";
import SchoolImg from "../../../../../assets/Images/TestImg/SchoolImg.png";
import ProfileImg from "../../../../../assets/Images/TestImg/profileImage.png";
import SignatureImg from "../../../../../assets/Images/TestImg/Signature.png";
import StudentProfileBarGraph from "./StudentProfileBarGraph.component";
import PDFBranding from "../../../../Universal/SAS Branding/PDFBranding.component";

const DownloadAttendanceRepor = forwardRef(({ studentData }, ref) => {
  return (
    <div className="hidden-print">
      <div
        ref={ref}
        className="w-full flex-col align-start g-1 justify-start back-white p-1 p-l-2 p-r-2 p-b-3"
      >
        {/* header */}
        <div className="flex-col align-center justify-start g-05">
          <div className="flex-col align-center justify-start">
            <img
              src={SchoolImg}
              style={{ width: "8rem", height: "8rem", objectFit: "cover" }}
              alt=""
            />
            <h3 className="f-24 poppins weight-500">
              Elementary School of Business and Social Sciences
            </h3>
          </div>
          <div className="w-full flex-col align-center justify-start g-2">
            <p className="t-16 color-grayColor poppins">Attendance report</p>
            <hr className="w-full" color="#b0b0b0" />
          </div>
        </div>
        <div className="flex-col align-start justify-between g-1">
          {/* profile viewer img name and id */}
          <div
            className="flex-row align-center justify-start g-1"
            style={{ height: "5rem" }}
          >
            <img
              src={ProfileImg}
              style={{ width: "5rem", height: "5rem", borderRadius: "50%" }}
              alt=""
            />
            <div className="h-full flex-col align-start justify-center">
              <h3 className="t-20 poppins weight-500">
                {studentData && studentData?.name}
              </h3>
              <p className="t-14 poppins color-textGray">
                ID: {studentData && studentData?.id}{" "}
              </p>
            </div>
          </div>

          {/* profile card sub  sec signatute */}
          <div className="flex-row align-center justify-between flex-1 w-full">
            <div
              className="flex-row align-center justify-center g-2"
              style={{ height: "5rem" }}
            >
              <div className="flex-col align-start justfy-center g-1">
                <div className="flex-row align-center justify-start">
                  <span className="poppins t-14">Class:</span>
                  <span
                    className="poppins t-14"
                    style={{ color: "var(--greenColor)" }}
                  >
                    {studentData && studentData?.academic.currentClass}
                  </span>
                </div>
                <div className="flex-row align-center justify-start">
                  <span className="poppins t-14">Section:</span>
                  <span
                    className="poppins t-14"
                    style={{ color: "var(--greenColor)" }}
                  >
                    {studentData && studentData?.academic.section}
                  </span>
                </div>
              </div>

              <div className="flex-col align-start justfy-center g-1">
                <div className="flex-row align-center justify-start">
                  <span className="poppins t-14">Roll:</span>
                  <span
                    className="poppins t-14"
                    style={{ color: "var(--greenColor)" }}
                  >
                    {studentData && studentData?.academic.rollNo}
                  </span>
                </div>

                <div className="flex-row align-center justify-start">
                  <span className="poppins t-14">Stars:</span>
                  <span
                    className="poppins t-14"
                    style={{ color: "var(--greenColor)" }}
                  >
                    {studentData && "20"}
                  </span>
                </div>
              </div>

              <div className="flex-col align-start justfy-center g-1">
                <div className="flex-row align-center justify-start">
                  <span className="poppins t-14">Date of Admission:</span>
                  <span
                    className="poppins t-14"
                    style={{ color: "var(--greenColor)" }}
                  >
                    {studentData && studentData?.academic.admissionData}
                  </span>
                </div>
                <div className="flex-row align-center justify-start">
                  <span className="poppins t-14">Date of Passing:</span>
                  <span
                    className="poppins t-14"
                    style={{ color: "var(--greenColor)" }}
                  >
                    {studentData && studentData?.academic.endSession}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex-col align-center justify-start g-1">
              <div
                className="flex-col align-center justify-start g-1 radius-6 p-05"
                style={{
                  border: "2px solid var(--orangeColor1)",
                  overflow: "hidden",
                }}
              >
                <img
                  src={SignatureImg}
                  style={{ width: "7vw", height: "2rem" }}
                  alt=""
                />
                <div className="poppins t-14">Teacher in Charge</div>
              </div>
            </div>
          </div>
        </div>
        {/* bar chart */}
        <div className="flex-col align-left w-full justify-start g-2 w-full">
          <div className="flex-1 flex-col g-2">
            <div className="flex-row align-center justify-between">
              <label htmlFor="title" className="t-18 color-grayColor poppins">
                Attendance and absence Month x classes (bar graph)
              </label>
              {/* tooltips */}
              <div className="flex-row align-center justify-start g-1">
                <div className="flex-row align-center justify-start g-05">
                  <div
                    style={{
                      width: "0.7rem",
                      height: "0.7rem",
                      borderRadius: "50%",
                      background: "#62B2FD",
                    }}
                  ></div>
                  <label htmlFor="title" className="t-12 poppins weight-500">
                    Attended
                  </label>
                </div>
                <div className="flex-row align-center justify-start g-05">
                  <div
                    style={{
                      width: "0.7rem",
                      height: "0.7rem",
                      borderRadius: "50%",
                      background: "#9BDFC4",
                    }}
                  ></div>
                  <label htmlFor="title" className="t-12 poppins weight-500">
                    Leaves
                  </label>
                </div>
              </div>
            </div>
            <StudentProfileBarGraph data="" />
          </div>

          <div
            className="flex-row align-center justify-start radius-6 p-2 p-t-2 g-2"
            style={{ background: "#62B2FD" }}
          >
            <div className="flex-col align-center justify-start g-05">
              <h3 className="color-white t-20 poppins-medium weight-500">
                Attendance
              </h3>
              <span className="t-23 color-white poppins-medium">
                2167 / 2496
              </span>
            </div>
            <div className="flex-row align-end justify-center">
              <span
                className="t-30 poppins-medium color-white responsive-text"
                style={{ fontSize: "3vw" }}
              >
                86.
              </span>
              <span
                className="t-20 poppins-medium color-white"
                style={{ fontSize: "2rem" }}
              >
                52
              </span>
              <span
                className="t-30 poppins-medium color-white"
                style={{ fontSize: "3rem" }}
              >
                %
              </span>
            </div>
          </div>
        </div>
        <div className="html2pdf__page-break"></div>
        {/* Absence Slabs (table data) */}
        <div className="flex-col align-start justify-start g-2">
          <h3 className="f-18 color-grayColor poppins-medium weight-500">
            Absence Slabs
          </h3>
          <div className="w-full flex">
            <table className="studentAbsentsTable">
              <thead>
                <tr>
                  <th>Reasons</th>
                  <th>Starting Date</th>
                  <th>Ending Date</th>
                  <th>Day Count</th>
                  <th>Reporting teachers</th>
                </tr>
              </thead>
              <tbody>
                {[...Array(6)].map(() => {
                  return (
                    <tr>
                      <td>Illness: High fever, cough and vomiting</td>
                      <td>02 October, 2024</td>
                      <td>03 October, 2024</td>
                      <td>1 days</td>
                      <td>Samir Rahaman</td>
                    </tr>
                  );
                })}

                <tr>
                  <td
                    colSpan={3}
                    className="t-18"
                    style={{
                      background: "transparent",
                      fontSize: "18px",
                      fontWeight: "bold",
                    }}
                  >
                    Total Absents
                  </td>
                  <td style={{ fontSize: "18px", fontWeight: "bold" }}>
                    30 days
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* table data download date */}
        <div className="flex-row align-center justify-start">
          <span className="poppins t-14">Date: 02 Oct, 2024</span>
        </div>
        {/* address and signatures */}
        <div className="flex-row align-center justify-between">
          <div
            style={{ width: "25vw" }}
            className="flex-col align-start justify-start g-05"
          >
            <h3 className="poppins-medium t-18 weight-500">
              Elementary School of Business and Social Sciences
            </h3>
            <address className="poppins t-14">
              15, Grand Trunk Rd, Deshbandhu Park, Uttarpara, Kolkata, West
              Bengal 700134
            </address>
          </div>

          <div className="flex-col align-center justify-center g-1">
            <img
              src={SignatureImg}
              style={{ width: "14rem", height: "4.5rem", objectFit: "contain" }}
              alt=""
            />
            <hr color="black" className="w-full" />
            <div className="poppins t-14 p-05">
              Authorized Signatory (Academic head)
            </div>
          </div>
        </div>
      </div>
      <PDFBranding />
    </div>
  );
});

export default DownloadAttendanceRepor;
